export default __webpack_public_path__ + "static/media/banner1.50e2a0de.png";